<template>
  <span class="stock-status-label" :class="`stock-status-label--${value}`">
    {{ text }}
  </span>
</template>

<script>
export default {
  props: ['value'],
  computed: {
    text() {
      if (this.value === true) {
        return '已使用';
      } return '';
    },
  },
};
</script>

<style scoped lang="scss">
.stock-status-label {
  display: inline-block;
  padding: 0.3rem 0.5rem;
  border-radius: 4px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;

  &--true {
    background: #E0EFFD;
    color: #3379BA;
  }

  &--false {
    display: none;
  }
}
</style>
